export default "__VITE_ASSET__IonuXAoD__"